import { CheckCircle2 } from 'lucide-react';

export default function CheckList({ items = [], columns = 2, tone = 'light' }) {
  const dark = tone === 'dark';
  return (
    <ul className={`grid gap-x-8 gap-y-3 ${columns === 2 ? 'sm:grid-cols-2' : ''} ${columns === 3 ? 'sm:grid-cols-2 lg:grid-cols-3' : ''}`}>
      {items.map((item) => (
        <li key={item} className={`flex gap-3 text-[0.95rem] leading-snug ${dark ? 'text-ink-200' : 'text-ink-700'}`}>
          <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-primary-500" aria-hidden="true" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
